import { render, staticRenderFns } from "./adminList.vue?vue&type=template&id=5a5f8be8&"
import script from "./adminList.vue?vue&type=script&lang=js&"
export * from "./adminList.vue?vue&type=script&lang=js&"
import style0 from "./adminList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "adminList.vue"
export default component.exports